<template>
  <div class="webhook-container">
    <Breadcrumb
      v-if="company || project"
      :company="company"
      :project="project"
      lastname="Webhook"
      ref="breadcrumb-webhook"
    />

    <el-card class="box-card select-company-project" style="overflow: inherit">
      <el-form :inline="true">
        <el-form-item label="Company">
          <model-list-select
            :list="dataCompany"
            v-model="company"
            option-value="uid"
            option-text="company_name"
            placeholder="All"
            @input="getProjectData"
          >
          </model-list-select>
        </el-form-item>
        <el-form-item label="Project">
          <model-list-select
            :list="dataProject"
            v-model="project"
            option-value="uid"
            option-text="project_name"
            placeholder="All"
            @input="projectActive"
          >
          </model-list-select>
        </el-form-item>
      </el-form>
    </el-card>

    <el-tabs v-model="webhookTabName">
      <el-tab-pane name="webhookfailed">
        <span slot="label"><i class="el-icon-error text-red"></i> Webhook failed to delivery</span>
        <WebhookFailed :company="company"/>
      </el-tab-pane>
      <el-tab-pane name="webhookconfig">
        <span slot="label"><i class="el-icon-setting"></i> Config</span>
        <WebhookConfig :project="project"/>
      </el-tab-pane>
      <el-tab-pane name="webhooktestapi">
        <span slot="label"><i class="el-icon-odometer"></i> Test Api</span>
        <WebhookTestApi :project="project"/>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";
import { getCompany } from "@/api/company";
import { getProjectByCompany, projectActive } from "@/api/project";
import Breadcrumb from "@/components/Breadcrumb";
import WebhookFailed from "./webhook-failed.vue";
import WebhookTestApi from "./webhook-testapi.vue";
import WebhookConfig from "./webhook-config.vue"

export default {
  components: {
    Breadcrumb,
    ModelListSelect,
    WebhookFailed,
    WebhookConfig,
    WebhookTestApi
  },
  computed: {
    ...mapGetters(["user_project", "company_uid"]),
    reportRole() {
      return this.roleAuth([this.role.spadmin, this.role.admin]);
    },
  },
  data() {
    return {
      company: "",
      project: "",
      dataCompany: [],
      dataProject: [],
      webhookTabName: "webhookfailed"
    };
  },
  methods: {
    getCompanyData() {
      getCompany().then(({ result, data }) => {
        if (result) {
          this.dataCompany = data;
          this.company = this.company_uid;
          this.getProjectData(this.company);
        }
      });
    },
    getProjectData(company) {
      this.project = "";
      this.dataProject = [];
      getProjectByCompany(company).then(async({ result, data }) => {
        if (result) {
          this.dataProject = data;
          if(company != this.company_uid){
            this.project = ""
            await this.$store.dispatch("user/setProject", {uid: ""});
          }else{
            this.project = this.user_project;
          }
          const selectedCompany = this.dataCompany.find((c) => c.uid === company);
          await this.$store.dispatch("user/setCompany", selectedCompany || {uid: company});
          this.$refs['breadcrumb-webhook'].reload()
        }
      });
    },
    projectActive(value) {
      this.project = value;
      projectActive(value).then(async ({ result }) => {
        if (result) {
          await this.$store.dispatch("user/getInfo");
          await this.$store.dispatch("user/setProject", {uid: value});
          this.$refs['breadcrumb-webhook'].reload()
        }
      });
    },
  },
  beforeUpdate() {},
  mounted() {
    
    this.getCompanyData();
  },
};
</script>

<style lang="scss">
.webhook-container {
  .select-company-project {
    .el-form-item__content {
      margin-right: 20px;
      min-width: 330px;
    }
  }

  .text-red{
    color: red;
  }
}
</style>
